import { HCPUserSubHeaderProps, ManufacturerSubHeaderProps, UserType } from "../../types/users";

export type ReportListingProps = {
  "Field Liaison Report": boolean;
  "Full Report": boolean;
  "Incoming Fax Report": boolean;
  "Login Report": boolean;
  "Status Report": boolean;
  "Refill Report": boolean;
  //"Pre Condensed Sales Report": boolean;
  // "Pre Refill Report": boolean;
  // "New Full Report": boolean;
  // "Old Full Report": boolean;
  "Condensed Sales Report": boolean;
};        

export type UserContextProps = {
  isUserAuthorized: boolean;
  isManufacturer: boolean;
  authToken: string;
  report_listing: ReportListingProps;
  userData: UserType | null;
  sub_header: HCPUserSubHeaderProps | ManufacturerSubHeaderProps | null;
  isRestoreCalled: boolean;
  createSession: (userData: UserType, report_listing: ReportListingProps, sub_header: HCPUserSubHeaderProps | ManufacturerSubHeaderProps, authToken: string) => void;
  destroySession: () => void;
  restoreSession: () => boolean;
  updateUserToken: (userToken: string) => void;
  updateUserData : (userData: UserType) => void;
};

export type AuthProviderProps = {
  children: JSX.Element;
};



export type AuthStateProps = {
  isUserAuthorized: boolean;
  isManufacturer: boolean;
  authToken: string;
  userData: UserType | null;
  sub_header: HCPUserSubHeaderProps | ManufacturerSubHeaderProps | null;
  isRestoreCalled: boolean;
  report_listing: ReportListingProps;
};

export enum AuthStateActions {
  SET_SESSION = 'setSession',
  UPDATE_USER_DATA = 'updateUserData',
  UPDATE_USER_TOKEN = 'updateUserToken',
  CLEAR_SESSION = 'clearSession'
};

export type AuthStateAction = {
  type: AuthStateActions.SET_SESSION;
  payload: AuthStateProps;
} | {
  type: AuthStateActions.UPDATE_USER_DATA;
  payload: UserType;
} | {
  type: AuthStateActions.UPDATE_USER_TOKEN;
  payload: string;
} | {
  type: AuthStateActions.CLEAR_SESSION;
};
